import { z } from 'zod';
import { UseSchema } from '../../common';

export const savedViewStateSchema = z
  .record(z.unknown())
  .describe('Serialized scene state (BCF viewpoint, sections, measurements, ...)');

export const savedViewBaseDtoSchema = z.object({
  name: z.string().min(1).max(255).describe('The display name of the saved view'),
  thumbnail: z
    .string()
    .nullable()
    .optional()
    .describe('Base64-encoded PNG snapshot of the scene at the time the view was saved'),
  state: savedViewStateSchema,
  bcfFileId: z
    .string()
    .uuid()
    .nullable()
    .optional()
    .describe(
      'Storage file ID of the BCF viewpoint JSON, uploaded by the client beforehand via the bcf-upload-url endpoint',
    ),
  isPublic: z
    .boolean()
    .optional()
    .describe('Whether the saved view is visible to all project viewers. Defaults to true.'),
});

export const savedViewCreateDtoSchema = savedViewBaseDtoSchema.extend({
  projectEntryId: z.string().uuid().describe('The ID of the project the saved view belongs to'),
});

@UseSchema(savedViewCreateDtoSchema)
export class SavedViewCreateDto {}
export interface SavedViewCreateDto extends z.input<typeof savedViewCreateDtoSchema> {}
